import { KeyValue } from "./Types";

export const createSelectOptions = (selectOptions: KeyValue[], selectedKey: string) => {
     return selectOptions.map(selectOption =>
         <option key={selectOption.key} value={selectOption.key}>{selectOption.value}</option>
    );
}
